import Link from '@mui/material/Link';

type DatadogLinkProps = {
  userId?: string;
  companyId?: string;
};

export const DatadogLink = ({ userId, companyId }: DatadogLinkProps) => {
  const env = import.meta.env.TREAD__ENV || 'staging';
  let queryParam = `service:(horizon-api OR horizon-api-worker) env:${env}`;
  if (userId) {
    queryParam += ` @current.principal_id:${userId}`;
  } else if (companyId) {
    queryParam += ` @current.company_id:${companyId}`;
  }
  const datadogUrl = `https://app.datadoghq.com/logs?query=${encodeURIComponent(queryParam)}`;
  return (
    <Link
      href={datadogUrl}
      target="_blank"
      rel="noopener noreferrer"
      variant="caption"
      color="primary"
      sx={{ fontSize: '0.75rem' }}
    >
      Datadog
    </Link>
  );
};
